module.exports = __webpack_public_path__ + "static/media/bg2.fdfdb228.jpeg";